import React, { useState, useRef, useCallback, useLayoutEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate, numberToLetter } from '../util';
import { Content } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import NumericInput from 'react-numeric-input';
import { getRawText, uniqueId } from '../util';
import { Sortable } from '../DragDrop';
import InteractiveRenderer from "../InteractiveRenderer";
const DraggablePanel = /*#__PURE__*/React.memo(({
  maxWidth,
  tab,
  index,
  dataProps,
  forceUpdate,
  children
}) => {
  const onMoveCallback = useCallback(() => {}, []);
  console.log("Width:", maxWidth);
  const onDropCallback = useCallback((fromIndex, result, didDrop) => {
    var _result$name;
    let toIndex = result === null || result === void 0 ? void 0 : (_result$name = result.name) === null || _result$name === void 0 ? void 0 : _result$name.current;
    console.log("CHECK", fromIndex, result, didDrop);
    if (fromIndex !== undefined && toIndex !== undefined && fromIndex !== toIndex) {
      console.log("DROPED", fromIndex, toIndex, didDrop);
      if (toIndex !== fromIndex) {
        const temp = dataProps.contents[fromIndex];
        dataProps.contents[fromIndex] = dataProps.contents[toIndex];
        dataProps.contents[toIndex] = temp;
        forceUpdate();
      }
    }
  });
  return /*#__PURE__*/React.createElement(Sortable, {
    style: {
      margin: "10px 10px",
      outline: "2px solid black",
      cursor: "move"
    },
    type: "TabPanel",
    key: index,
    id: uniqueId(tab),
    index: index,
    onMove: onMoveCallback,
    onDrop: onDropCallback,
    horizontal: true
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${maxWidth / dataProps.contents.length * .8}px`,
      textAlign: "center"
    }
  }, children));
});
export default function TaskTabPanel(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const tabArrangRef = useRef(null);
  const [tabArrangWidth, setTabArrangWidth] = useState(0);
  useLayoutEffect(() => {
    var _tabArrangRef$current;
    setTabArrangWidth((_tabArrangRef$current = tabArrangRef.current) === null || _tabArrangRef$current === void 0 ? void 0 : _tabArrangRef$current.offsetWidth);
  }, [props]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Tab Overview"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    ref: tabArrangRef
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Tab Arrangement:")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, dataProps.contents.map((tab, index) => {
    console.log();
    return /*#__PURE__*/React.createElement(DraggablePanel, {
      maxWidth: tabArrangWidth,
      tab: tab,
      index: index,
      dataProps: dataProps,
      forceUpdate: forceUpdate
    }, getRawText(tab.title));
  }))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of Tabs:")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 2,
    max: 5,
    value: dataProps.contents.length,
    onChange: e => {
      if (e) {
        let delta = e - dataProps.contents.length;
        if (delta > 0) {
          for (let i = 0; i < Math.abs(delta); ++i) {
            dataProps.contents.push({
              title: new Content("New Tab"),
              contents: new Content("Lorem ipsum dolor sit amet")
            });
          }
        } else if (delta < 0) {
          for (let i = 0; i < Math.abs(delta); ++i) {
            dataProps.contents.pop();
          }
        }
        props.triggerStateUpdate();
        forceUpdate();
        props.onChanged();
      }
    }
  }))))), dataProps.contents.map((tab, index) => {
    const letter = numberToLetter(index);
    //console.log("tab", tab)
    return /*#__PURE__*/React.createElement(TabContextReporter, {
      index: String(index + 1),
      title: getRawText(tab.title)
    }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Title:"))), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove tab",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        dataProps.contents.splice(index, 1);
        props.triggerStateUpdate();
        props.onChanged();
        props.decrementActiveTab();
      }
    }))), /*#__PURE__*/React.createElement(RichText, {
      value: tab.title,
      inlineOnly: true,
      onChange: v => {
        tab.title = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        props.scopeToItem(props.data, ["props", "contents", index, "contents"]);
      }
    }, "Edit Tab ", letter), /*#__PURE__*/React.createElement("hr", null))));
  }));
}